export const area_url: string = "area";